import React, { useState, useRef, useEffect } from 'react';
import './FilterDropdown.css';

/**
 * Multi-select checkbox dropdown filter.
 * @param {string} label - Display label when nothing is selected
 * @param {string[]} options - Available options
 * @param {string[]} selected - Currently selected values
 * @param {function} onChange - Callback with updated selected array
 */
function FilterDropdown({ label, options, selected, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  // Close on outside click
  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const allSelected = selected.length === 0;

  const toggle = (val) => {
    if (selected.includes(val)) {
      onChange(selected.filter((s) => s !== val));
    } else {
      onChange([...selected, val]);
    }
  };

  const selectAll = () => onChange([]);

  const displayText = allSelected
    ? label
    : selected.length === 1
      ? selected[0]
      : `${selected.length} selected`;

  return (
    <div className="fd" ref={ref}>
      <button
        className={`fd-trigger ${open ? 'fd-trigger--open' : ''} ${!allSelected ? 'fd-trigger--active' : ''}`}
        onClick={() => setOpen((o) => !o)}
        type="button"
      >
        <span className="fd-trigger-text">{displayText}</span>
        <svg className={`fd-chevron ${open ? 'fd-chevron--open' : ''}`} width="10" height="6" viewBox="0 0 10 6" fill="none"><path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
      </button>

      {open && (
        <div className="fd-menu">
          <label className="fd-option">
            <input
              type="checkbox"
              className="fd-checkbox"
              checked={allSelected}
              onChange={selectAll}
            />
            <span className="fd-checkmark" />
            <span className="fd-option-label">All</span>
          </label>

          <div className="fd-divider" />

          {options.map((opt) => (
            <label className="fd-option" key={opt}>
              <input
                type="checkbox"
                className="fd-checkbox"
                checked={selected.includes(opt)}
                onChange={() => toggle(opt)}
              />
              <span className="fd-checkmark" />
              <span className="fd-option-label">{opt}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
}

export default FilterDropdown;
